module.exports = __webpack_public_path__ + "img/1440.b95df923.jpg";